import request from '@/axios'
import Common from '@/assets/js/common'

// 登录
export const AccountLogin = (params) => {
  return request('/admin/login', Common.concatParams(params), 'post')
}
// 退出登录
export const Accountlogout = () => {
  return request(`/admin/logout`, {}, 'post')
}
// 修改密码
export const setPassword = (params) => {
  return request(`/admin/employee/changePassword/${params.employeeId}`, Common.concatParams(params), 'post')
}
// 添加积分规则
export const addPointrule = (params) => {
  return request(`/admin/pointrule`, params, 'post')
}
// 修改积分规则
export const updatePointrule = (params) => {
  return request(`/admin/pointrule/${params.ruleId}`, params, 'post')
}
// 获取积分规则
export const getPointrule = () => {
  return request(`/admin/pointRule`, {}, 'get')
}
// 获取菜单
export const getMenuList = () => {
  return request(`/admin/getAuthorityPages`, {}, 'get')
}
// 检验手机号是否注册
export const verifyMobile = (params) => {
  return request(`/admin/registry/verifyMobile?mobile=${params}`, {}, 'get')
}
// 获取省份
export const getProvince = () => {
  return request(`/admin/province`, {}, 'get')
}
// 获取城市
export const getCity = (provinceId) => {
  return request(`/admin/city/${provinceId}`, {}, 'get')
}
// 获取城市
export const getCounty = (cityId) => {
  return request(`/admin/district/${cityId}`, {}, 'get')
}



// WEBPACK FOOTER //
// ./src/api/user/index.js